import { InfoIcon } from 'lucide-react'

import { PortalControlTriggerButton } from '@/pages/client-portal/internal/ui/client-portal-internal-header/portal-control/portal-control-trigger-button/portal-control-trigger-button'
import { CaseNavigation } from '@/pages/client-portal/ui/case-navigation/case-navigation'
import { CopyLinkButton } from '@/pages/client-portal/ui/copy-link-button/copy-link-button'
import { HeaderWrapper } from '@/pages/client-portal/ui/header-wrapper/header-wrapper'
import { SelectOtherCasesButton } from '@/pages/client-portal/ui/select-other-cases-button/select-other-cases-button'

import { cn } from '@/lib/utils'

import { PortalControlSheet } from './portal-control/portal-control-sheet/portal-control-sheet'
import { useClientPortalInternalHeader } from './use-client-portal-internal-header'

export const ClientPortalInternalHeader = () => {
  const {
    currentCaseId,
    currentCaseNumber,
    copiedUrl,
    dataAllApplicantCases,
    dataProUserSelectedCases,
    portalOption,
    beingUpdatedCaseId,
    isOpenPortalControlSheet,
    isUscisCase,
    isDisabledAllCheckbox,
    isLoadingPortalControlSaveButton,
    handleClickPreviousButton,
    handleClickCase,
    handleClickNextButton,
    handleChangeCaseChecked,
    handleClickPortalControlTriggerButton,
    handleClickPortalControlSaveButton,
    handlePortalControlSheetOpen,
  } = useClientPortalInternalHeader()

  return (
    <>
      <div className={cn('flex flex-col gap-y-4 lg:flex-row lg:gap-x-2.5', 'mb-4')}>
        <p
          className={cn(
            'flex items-center gap-x-2',
            'text-slate-600',
            'px-4 py-2',
            'rounded-[10px] border border-slate-100'
          )}
        >
          <InfoIcon size={16} className={cn('min-w-4')} />
          <span className={cn('text-xs font-medium')}>
            Language translation is available to your client when the portal is shared.
          </span>
        </p>
        <div className={cn('flex gap-x-2.5', 'ml-auto')}>
          <SelectOtherCasesButton
            dataAllApplicantCases={dataAllApplicantCases}
            dataProUserSelectedCases={dataProUserSelectedCases}
            beingUpdatedCaseId={beingUpdatedCaseId}
            isDisabledAllCheckbox={isDisabledAllCheckbox}
            onCheckedChange={handleChangeCaseChecked}
          />
          <CopyLinkButton copiedUrl={copiedUrl} />
        </div>
      </div>

      {/* Mobile */}
      <HeaderWrapper className={cn('flex flex-col lg:hidden', 'py-[18px]')}>
        <p className={cn('h-[14px]', 'text-[14px] font-medium leading-[14px] text-muted-foreground text-slate-400')}>
          Case number
        </p>

        <div
          className={cn(
            'flex flex-row items-center justify-between gap-x-4',
            'max-[400px]:flex-col max-[400px]:items-start max-[400px]:gap-y-3',
            'mt-2'
          )}
        >
          <p className={cn('h-[32px]', 'text-2xl font-semibold text-primary-foreground')}>{currentCaseNumber}</p>

          <PortalControlTriggerButton className={cn('ml-auto')} onClick={handleClickPortalControlTriggerButton} />
        </div>

        <p
          className={cn(
            'flex items-center gap-x-2',
            'w-fit',
            'ml-auto mt-4',
            'text-xs font-medium text-slate-300',
            'py-2'
          )}
        >
          <InfoIcon size={16} className={cn('min-w-4')} />
          <span>Your client doesn&apos;t have access to Portal Control</span>
        </p>

        <div className={cn('fixed bottom-0 left-0 right-0 z-[1]', 'px-5 py-[18px]', 'bg-slate-700')}>
          <CaseNavigation
            currentCaseId={currentCaseId}
            proUserSelectedCases={dataProUserSelectedCases}
            onClickPreviousButton={handleClickPreviousButton}
            onClickCase={handleClickCase}
            onClickNextButton={handleClickNextButton}
          />
        </div>
      </HeaderWrapper>

      {/* Desktop */}
      <HeaderWrapper className={cn('py-6')}>
        <p className={cn('text-xl font-normal text-slate-400', 'test')}>Case number</p>
        <div className={cn('flex items-center gap-x-6', 'mt-3')}>
          <p className={cn('text-[40px] font-extrabold leading-[48px] text-primary-foreground', 'h-[48px]')}>
            {currentCaseNumber}
          </p>
          <PortalControlTriggerButton onClick={handleClickPortalControlTriggerButton} />
          <p className={cn('flex items-center gap-x-2', 'w-fit', 'text-xs font-medium text-slate-300', 'py-2')}>
            <InfoIcon size={16} className={cn('min-w-4')} />
            <span>Your client doesn&apos;t have access to Portal Control</span>
          </p>
          <div className={cn('ml-auto')}>
            <CaseNavigation
              currentCaseId={currentCaseId}
              proUserSelectedCases={dataProUserSelectedCases}
              onClickPreviousButton={handleClickPreviousButton}
              onClickCase={handleClickCase}
              onClickNextButton={handleClickNextButton}
            />
          </div>
        </div>
      </HeaderWrapper>

      {/* Portal Control */}
      <PortalControlSheet
        isOpen={isOpenPortalControlSheet}
        isLoadingSaveButton={isLoadingPortalControlSaveButton}
        isUscisCase={isUscisCase}
        caseNumber={currentCaseNumber}
        defaultPortalOption={portalOption}
        onChangeOpen={handlePortalControlSheetOpen}
        onClickSaveButton={handleClickPortalControlSaveButton}
      />
    </>
  )
}
